import { useCallback, useMemo } from 'react';

import { useGetChainIdQuery } from 'modules/auth/actions/getChainId';

import { useConnectMutation } from '../actions/connect';
import { useDisconnectMutation } from '../actions/disconnect';
import { CONNECTION_CACHE_KEY } from '../const';

export function useConnection() {
  const [connect, { data, isLoading: isConnectLoading }] = useConnectMutation({
    fixedCacheKey: CONNECTION_CACHE_KEY,
  });

  const { data: chainId } = useGetChainIdQuery(undefined, {});

  const [dispatchDisconnect, { isLoading: isDisconnectLoading }] =
    useDisconnectMutation({
      fixedCacheKey: CONNECTION_CACHE_KEY,
    });

  const handleDisconnect = useCallback(async () => {
    if (data?.walletId) {
      await dispatchDisconnect({ walletId: data.walletId });
    }
  }, [data, dispatchDisconnect]);

  const actualData = useMemo(
    () => ({
      ...data,
      chainId: chainId ?? data?.chainId,
    }),
    [data, chainId],
  );

  return {
    isLoading: isConnectLoading || isDisconnectLoading,
    data: actualData,
    connect,
    disconnect: handleDisconnect,
    isConnected: data?.address,
  };
}
